// tslint:disable:no-var-requires
require('angulartics');

export default angular.module('app.core', [
  // ng core mods
  'ngAnimate',
  'ngResource',
  'ngMaterial',
  'ngMessages',
  'ngSanitize',

  // vendor mods
  'ui.router',
  'angular-md5',
  'ncy-angular-breadcrumb',
  'angular-jwt',
  'agGrid',
  'ngIdle',
  'flux',
  'ngFileSaver',
  'mdSteppers',
  'angulartics',
  // require('angulartics-google-analytics'), Removed due to conflict with tag manager plugin
  require('angulartics-google-tag-manager'),
  'tandibar/ng-rollbar',
]).name;
